export const PAGE_ROUTES = {
  HOME: "/",
  CRM: "/leads",
  PROFILE: "/profile",
  LOGIN: "/login",
  ORGANIZATIONS: "/organization",
  INSTANCES: "/instance",
  INSTANCE: "/instance/:id",
  CAMPAIGNS: "/campaign",
  CAMPAIGN: "/campaign/:id",
  CAMPAIGN_CREATE: "/campaign/create",
  LISTS: "/list",
  LIST: "/list/:id",
  CHAT: "/chat",
  CHAT_WITH_PARAMS: "/chat/:campaign_id/:convo_agent_conversion_id",
  NOTIFICATIONS: "/notification",
  USERS: "/users",
  SUCCESS: "/success",
  FAILED: "/failed",

  DASHBOARD: "/dashboard",
};
